module.exports = __webpack_public_path__ + "img/logo.44065e00.png";